import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import LeftBar from '../Site/CustomerBar';
import OrderPrint from './OrderPrint';

import './style.css';

class OrderPrintDetail extends Component { 
  
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    
    const { location } = this.props
    //console.log('path: '+ location.pathname );
    const { selectedIds } = this.props.location.state;
    //console.log('selectedIds from OrderPrintDetail: ' + selectedIds);

    var pathArray = location.pathname.split('/');
    //pathArray[1] = order
    //pathArray[2] = client id
    //pathArray[3] = order id
    
    this.state = {
        cl_id: pathArray[2],
        or_id: pathArray[3],
        selectedIds: selectedIds
    };
  }

  render() {      
    
    return (
      <div>       
        <LeftBar />
        <OrderPrint cl_id={this.state.cl_id} or_id={this.state.or_id} selectedIds={this.state.selectedIds} />
      </div>    


    );
  }
}

export default withRouter(OrderPrintDetail);